import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';

import chartsReducer from './charts/slice';
import commentReducer from './comment/slice';
import { rtkApi } from './rtkApi';
import agentReducer from './slices/agent';
import analyticsReducer from './slices/analytics';
import bannerReducer from './slices/banner';
import broadcastReducer from './slices/broadcast';
import challengeReducer from './slices/challenge';
import clientReducer from './slices/client';
import complexReducer from './slices/complex';
import constantReducer from './slices/constant';
import countryReducer from './slices/country';
import courseReducer from './slices/course';
import dictionaryAutomoderationReducer from './slices/dictionaryAutoModeration';
import dietReducer from './slices/diet';
import disablePaymentReducer from './slices/disablePayment';
import faqReducer from './slices/faq';
import groupReducer from './slices/group';
import intensityReducer from './slices/intensity';
import levelReducer from './slices/level';
/** @deprecated Старая структура марафонов, будет заменена */
import marathonReducer from './slices/marathon';
import notificationReducer from './slices/notification';
import orderReducer from './slices/order';
import photoMapReducer from './slices/photoMap';
import productReducer from './slices/product';
import promocodeReducer from './slices/promocode';
import promotionReducer from './slices/promotion';
import recurrentReducer from './slices/recurrent';
import referralProgrammeReducer from './slices/referralProgramme';
import socialsReducer from './slices/socials';
import storyReducer from './slices/story';
import trainerReducer from './slices/trainer';
import tutorialReducer from './slices/tutorial';
import useDeskReducer from './slices/usedesk';
import userReducer from './slices/user';
import versionReducer from './slices/version';
import workoutReducer from './slices/workout';

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
  user: userReducer,
  client: clientReducer,
  product: productReducer,
  order: orderReducer,
  course: courseReducer,
  /** @deprecated Старая структура марафонов, будет заменена */
  marathon: marathonReducer,
  challenge: challengeReducer,
  tutorial: tutorialReducer,
  group: groupReducer,
  trainer: trainerReducer,
  country: countryReducer,
  constant: constantReducer,
  notification: notificationReducer,
  socials: socialsReducer,
  analytics: analyticsReducer,
  version: versionReducer,
  usedesk: useDeskReducer,
  agent: agentReducer,
  intensity: intensityReducer,
  level: levelReducer,
  comment: commentReducer,
  dictionaryAutomoderation: dictionaryAutomoderationReducer,
  referralProgramme: referralProgrammeReducer,
  promotion: promotionReducer,
  promocode: promocodeReducer,
  banner: bannerReducer,
  story: storyReducer,
  workout: workoutReducer,
  complex: complexReducer,
  broadcast: broadcastReducer,
  photoMap: photoMapReducer,
  diet: dietReducer,
  faq: faqReducer,
  disablePayment: disablePaymentReducer,
  recurrent: recurrentReducer,
  charts: chartsReducer,
  [rtkApi.reducerPath]: rtkApi.reducer,
});

export { rootPersistConfig, rootReducer };
